import { compose, filter, identity, isEmpty, map, propOr, split } from 'ramda'

import { useQueryParams } from '../../../../utils/contexts/UrlProvider'
import { useStatusOptionFormatter } from '../../../../utils/helpers/status'

export const useUrlFilters = () => {
  const formatStatus = useStatusOptionFormatter()
  const qp = useQueryParams()

  const statuses = compose(map(formatStatus), filter(identity), split(','), propOr('', 'status'))(qp)

  const createdAt = compose(
    map(v => new Date(v)),
    filter(identity),
    split(','),
    propOr('', 'createdAt')
  )(qp)

  const filterObj = qp?.filters ? JSON.parse(qp.filters) : {}

  if (!isEmpty(statuses)) {
    filterObj.statusIds = statuses
  }

  if (!isEmpty(createdAt)) {
    filterObj.createdAt = createdAt
  }

  if (isEmpty(filterObj)) return {}
  return { filter: filterObj }
}
